"use client"
import HeroSection from 'src/app/components/heroSection/HeroSection'
import GetStartedSection from 'src/app/components/GetStartedSection'
import MainSection from 'src/app/components/heroSection/MainSection'
const RolzoWorldMap = dynamic(() => import('./_components/RolzoWorldMap'))
const SolutionSection = dynamic(() => import('./_components/SolutionSection'))
const WhyRolzoSection = dynamic(() => import('./_components/WhyRolzoSection'))

import GlobalSearch from '@/components/globalSearch/GlobalSearch'
import dynamic from 'next/dynamic'
import miamiImg from 'images/ROLZO MIAMI RGB.webp'
import mexicoImg from 'images/Hero-MEXICO-RGB.jpg'
import parisImg from 'images/Hero-PARIS-RGB.jpg'
import NYImg from 'images/Hero-NY-RGB.webp'
import londoniImg from 'images/Hero-LONDON-RGB.webp'
import defaultImg from 'images/homepageimg.webp'
import GlobalSearchLoading from '@/components/globalSearch/GlobalSearchLoading'
import RolzoServices from './_components/RolzoServices'
import { Suspense, useEffect, useState } from 'react'
import OrgInfiniteCarousel from '@/components/OrgInfiniteCarousel'
import { useLocale, useTranslations } from 'next-intl'




const Home = () => {
  const [ipLocation, setIpLocation] = useState("AE")
  const locale = useLocale()
  useEffect(() => {
    const getIpLocation = async () => {
      const fetchedData = await fetch(
        `${process.env.NEXT_PUBLIC_API_URL}getIpLocation/`
      )
      const result = await fetchedData.json()
      if (!result.ok) {
        return { message: 'Failed to get Ip location' }
      }
      setIpLocation(result.data.ipCountry)
    }
    getIpLocation()
  }, [])

  const CITY_IMAGE_MAP = {
    'US-Miami': miamiImg,
    MX: mexicoImg,
    FR: parisImg,
    US: NYImg,
    GB: londoniImg,
  }

  const getCityImageUrl = (locale) => {
    return (
      CITY_IMAGE_MAP[ipLocation] ||
      (locale === 'es' ? mexicoImg : locale === 'fr' ? parisImg : locale === 'pt-BR' ? defaultImg : londoniImg)
    )
  }

  const t_mainSection = useTranslations('home-page.main-section')
  const t = useTranslations('home-page')
  return (
    <main className=' min-h-screen home'>
      <HeroSection>
        <div className='col-span-12 px-[15px]'>
          <MainSection
            homepage={true}
            t={t_mainSection}
            imgSrc={getCityImageUrl(locale)}
            locale={locale}
          />
        </div>
        {/* <div className='col-span-5 px-[15px]'>
          <Suspense fallback={<GlobalSearchLoading />}>
            <GlobalSearch />
          </Suspense>
        </div> */}
      </HeroSection>
      <OrgInfiniteCarousel
        homepage
        title={t('infiniteCompaniesScroll.title')}
        isShowButton
      />
      <RolzoServices
        locale={locale}
      />
      <RolzoWorldMap />
      <SolutionSection />
      <WhyRolzoSection />
      <GetStartedSection
        firstButtonText="Start now"
        locale={locale} />
    </main>
  )
}

export default Home
